import { create } from 'zustand';
import type { ProfileSectionKey } from '@/components/layout/ProfileSidebar';

interface ProfileSectionStore {
  activeSection: ProfileSectionKey;
  setActiveSection: (key: ProfileSectionKey) => void;
}

export const useProfileSectionStore = create<ProfileSectionStore>((set) => ({
  activeSection: 'info',
  setActiveSection: (key) => set({ activeSection: key }),
}));
